export { default as toPathFactories } from './toPathFactories'
export { toPathFactory } from './toPathFactories'
